export const StateKey = {
    DefaultValues: 'DefaultValues',
    DirtyValues: 'DirtyValues',
    QueryString: 'QueryString'
}